export default __webpack_public_path__ + "static/media/about-us-2.fb099dae.svg";